export const SUBJECT_DATA = {
  811: "복리후생비",
  812: "여비교통비",
  813: "접대비",
  814: "통신비",
  815: "수도광열비",
  816: "전력비",
  817: "세금과공과",
  819: "임차료",
  820: "수선비",
  821: "보험료",
  822: "차량유지비",
  823: "연구개발비",
  824: "운반비",
  825: "교육훈련비",
  826: "도서인쇄비",
  827: "회의비",
  828: "포장비",
  829: "사무용품비",
  830: "소모품비",
  831: "수수료비용",
  832: "보관료",
  833: "광고선전비",
  834: "판매촉진비",
  836: "기밀비",
  837: "건물관리비",
  951: "이자비용",
  953: "기부금",
};

export const SUBJECT_LIST = Object.entries(SUBJECT_DATA).map(
  ([key, value]) => ({ value: key, label: value })
);
